<template>
  <label
    class="label"
    :style="getRootStyles"
  >
    <input
      type="radio"
      :value="value"
      v-model="model"
      hidden
    >

    <!-- CUSTOM CHECKBOX -->
    <div
      class="radio"
      :style="getRadioStyles"
      :class="getRadioClasses"
    />

    <span>{{ label }}</span>
  </label>
</template>

<script>
export default {
  name: 'BaseRadio',
  props: {
    /* active value */
    modelValue: {},
    /* current value */
    value: {
      type: [String, Number, Boolean]
    },
    /* title */
    label: {
      type: [String, Number],
      default: ''
    },
    /* radio-btn size */
    size: {
      type: Number,
      default: 14
    },
    /* is disabled */
    disabled: {
      type: Boolean,
      default: false
    },
    /* active color */
    color: {
      type: String,
      default: '#EE740F'
    }
  },
  emits: {
    'update:modelValue': null
  },
  computed: {
    model: {
      get () {
        return this.modelValue
      },
      set (value) {
        this.$emit('update:modelValue', value)
      }
    },
    /* if radio checked => true, else => false  */
    isChecked () {
      return this.modelValue === this.value
    },
    /* ROOT STYLES */
    getRootStyles () {
      return {
        'pointer-events': this.disabled ? 'none' : null
      }
    },
    /* RADIO-BTN STYLES */
    getRadioStyles () {
      const padding = this.size * 0.15 + 'px'

      return {
        width: this.size + 'px',
        height: this.size + 'px',
        backgroundColor: this.isChecked ? this.color : null,
        padding: this.isChecked ? padding : null,
        borderColor: this.color
      }
    },
    /* RADIO-BTN CLASSES */
    getRadioClasses () {
      const status = this.isChecked ? 'active' : 'inactive'
      return {
        [`radio_${status}`]: true,
        [`radio_${status}_disabled`]: this.disabled
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$disabled-color: #dce1e8;

.label {
  display: flex;
  align-items: center;
  padding: 3px 0;

  .radio {
    border-radius: 1000px;
    border: 1px solid;
    position: relative;
    margin-right: 8px;

    &_active {
      padding: 3.5px;
      background-clip: content-box;

      &_disabled {
        background-color: $disabled-color !important;
        border-color: $disabled-color !important;
      }
    }

    &_inactive {
      background-color: transparent;

      &_disabled {
        border-color: $disabled-color !important;
      }
    }
  }
}
</style>
